import React, { useState } from 'react'
import { Divider, TextField, Select, DropdownMenuPosition } from '@duik/it'
import CreateNewSiteMap from '../Maps/CreateNewSiteMap'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import LargeModal from '../../../UI/LargeModal'
import {
  HeadingText,
  HeadingSubText,
  LeftContainer,
  RightContainer,
  ContainerWrapper,
  DriverInstructionTextArea,
  LabelText,
  TextFieldContainer,
  FormContainer,
  ErrorMessageSpan,
  HalfWidthGroup,
  SecondRowContainter,
  InputContainer
} from './styles'

const CreateNewSite = props => {
  const [locationScreen, setLocationScreen] = useState(false)
  const [coordinates, setCoordinates] = useState({})
  const [customCoordinates, setCustomCoordinates] = useState([])
  const [radius, setRadius] = useState(0)

  const screenToggle = () => {
    setLocationScreen(!locationScreen)
  }

  const locationCoordinatesEntry = (customCoordinates, siteCenter, radius) => {
    setCoordinates(siteCenter)
    setRadius(radius)
    setCustomCoordinates(customCoordinates)
    screenToggle()
  }

  const createNewSite = values => {
    const { siteName, company, type, project, defaultInstructions } = values
    props.createSite(
      siteName,
      company,
      coordinates,
      customCoordinates,
      radius,
      type,
      project,
      defaultInstructions
    )
    props.createNewSiteModalToggle()
  }

  return (
    <Formik
      initialValues={{
        siteName: '',
        company: '',
        type: '',
        project: '',
        defaultInstructions: ''
      }}
      validationSchema={SiteSchema}
      handleSubmit={e => console.log('')}
      onSubmit={values => {
        createNewSite(values)
      }}
      render={({
        values,
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched
      }) => (
        <LargeModal
          handleLinkClick={props.createNewSiteModalToggle}
          handleSaveButton={handleSubmit}
          title="Create New Site"
          saveButtonText="Create"
          saveButtonDisabled={
            isSubmitting ||
            !touched.siteName ||
            errors.siteName ||
            !touched.company ||
            errors.company ||
            !customCoordinates.length
          }
        >
          <form onSubmit={handleSubmit}>
            <FormContainer>
              <ContainerWrapper>
                <LeftContainer>
                  <HeadingText>Details</HeadingText>
                </LeftContainer>
                <RightContainer>
                  <InputContainer>
                    <HalfWidthGroup>
                      <TextFieldContainer>
                        <TextField
                          className="newInputBox"
                          label="Site Name"
                          name="siteName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.siteName}
                        />
                        <ErrorMessage
                          name="siteName"
                          render={msg => <ErrorMessageSpan>{msg}</ErrorMessageSpan>}
                        />
                      </TextFieldContainer>
                    </HalfWidthGroup>
                    <HalfWidthGroup>
                      <TextFieldContainer>
                        <TextField
                          className="newInputBox"
                          label="Company"
                          name="company"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.company}
                        />
                        <ErrorMessage
                          name="company"
                          render={msg => <ErrorMessageSpan>{msg}</ErrorMessageSpan>}
                        />
                      </TextFieldContainer>
                    </HalfWidthGroup>
                  </InputContainer>
                  <SecondRowContainter>
                    <HalfWidthGroup>
                      <TextFieldContainer>
                        <Select
                          className="siteSelect optionsFullWidth"
                          activeOption={{
                            value: values.type,
                            label: values.type
                          }}
                          label="Type"
                          name="type"
                          options={[
                            {
                              value: 'Dump',
                              label: 'Dump'
                            },
                            {
                              value: 'Project',
                              label: 'Project'
                            },
                            {
                              value: 'Source',
                              label: 'Source'
                            },
                            {
                              value: 'Transfer',
                              label: 'Transfer'
                            }
                          ]}
                          menuPosition={DropdownMenuPosition['bottom-right']}
                          onOptionClick={e => {
                            setFieldValue('type', e.value)
                          }}
                          placeholder={<></>}
                        />
                        <ErrorMessage
                          name="type"
                          render={msg => <ErrorMessageSpan>{msg}</ErrorMessageSpan>}
                        />
                      </TextFieldContainer>
                    </HalfWidthGroup>
                    {values.type === 'Project' ? (
                      <HalfWidthGroup>
                        <TextFieldContainer>
                          <Select
                            className="siteSelect"
                            activeOption={{
                              value: values.project,
                              label: values.project.projectName
                            }}
                            label="Project"
                            name="project"
                            options={[
                              ...props.projectList.map(item => ({
                                value: item,
                                label: item.projectName
                              }))
                            ]}
                            menuPosition={DropdownMenuPosition['bottom-right']}
                            onOptionClick={e => {
                              setFieldValue('project', e.value)
                            }}
                          />
                          <ErrorMessage
                            name="project"
                            render={msg => <ErrorMessageSpan>{msg}</ErrorMessageSpan>}
                          />
                        </TextFieldContainer>
                      </HalfWidthGroup>
                    ) : null}
                  </SecondRowContainter>
                </RightContainer>
              </ContainerWrapper>
              <Divider />
              <ContainerWrapper>
                <LeftContainer>
                  <HeadingText>Driver Instructions</HeadingText>
                  <HeadingSubText>These will be sent when dispatching trucks</HeadingSubText>
                </LeftContainer>
                <RightContainer>
                  <div>
                    <LabelText>Default</LabelText>
                    <DriverInstructionTextArea
                      name="defaultInstructions"
                      value={values.defaultInstructions}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </RightContainer>
              </ContainerWrapper>
              <Divider />
              <ContainerWrapper>
                <LeftContainer>
                  <HeadingText>Geo-fence</HeadingText>
                  <HeadingSubText>Draw the perimeter of the site</HeadingSubText>
                </LeftContainer>
                <RightContainer>
                  <CreateNewSiteMap
                    screenToggle={screenToggle}
                    locationCoordinatesEntry={locationCoordinatesEntry}
                    editSiteDetail={props.editSiteDetail}
                  />
                </RightContainer>
              </ContainerWrapper>
            </FormContainer>
          </form>
        </LargeModal>
      )}
    />
  )
}

export default CreateNewSite

const SiteSchema = Yup.object().shape({
  siteName: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  company: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required')
})
